export interface IPopperEvents {
  show: (event?: Event) => void;
  hide: (event?: Event) => void;
}
